import { formatDayColumn, getDayColumnIndexes } from "@domain/program/program";
import { ProgramContentEditor } from "@domain/program/program-content-editor";
import styled from "@emotion/styled";
import { MobileDayColumn } from "@ui/pages/program-builder/mobile/mobile-day-column";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint } from "@ui/style";
import { colors } from "@ui/style/colors";
import { useObservable } from "micro-observables";
import React from "react";

interface MobileDayCarouselProps {
	programEditor: ProgramContentEditor;
	className?: string;
}

export const MobileDayCarousel = ({ programEditor, className }: MobileDayCarouselProps): JSX.Element => {
	const editedProgram = useObservable(programEditor.editedProgram);

	return (
		<DayTableContainer>
			{getDayColumnIndexes().map(dayIndex => (
				<MobileDayColumn
					className={className}
					key={dayIndex}
					dayIndex={dayIndex}
					title={formatDayColumn(dayIndex, "long")}
					session={editedProgram.days.get(dayIndex)}
					programEditor={programEditor}
				/>
			))}
		</DayTableContainer>
	);
};

const DayTableContainer = styled.div`
	scroll-snap-type: x mandatory;
	scroll-padding: 32px;
	display: grid;
	grid-auto-flow: column;
	gap: 12px;
	overflow-x: auto;
	overflow-y: hidden;
	padding: 16px;
	padding-top: 8px;
	min-height: 100vh;
	background-color: ${colors.white};

	@media ${physioMeTabletBreakpoint} {
		grid-auto-columns: 375px;
	}

	@media ${physioMeMobileBreakpoint} {
		grid-auto-columns: 85vw;
	}
`;
